import { render, staticRenderFns } from "./RoomItem.vue?vue&type=template&id=eb646e8e&scoped=true&"
import script from "./RoomItem.vue?vue&type=script&lang=js&"
export * from "./RoomItem.vue?vue&type=script&lang=js&"
import style0 from "./RoomItem.vue?vue&type=style&index=0&id=eb646e8e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb646e8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eb646e8e')) {
      api.createRecord('eb646e8e', component.options)
    } else {
      api.reload('eb646e8e', component.options)
    }
    module.hot.accept("./RoomItem.vue?vue&type=template&id=eb646e8e&scoped=true&", function () {
      api.rerender('eb646e8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/event1/components/rolls/components/RoomItem.vue"
export default component.exports